import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  PLATFORM_ID,
  Inject,
} from '@angular/core';
import {
  ChecklistDetailsResponse,
  ChecklistDetailsFileLinkWithThumbnail,
  StyleSettingsDealerImage,
  DealerMediaResponse,
  Client,
  ChecklistDetailsCategories,
  ChecklistDetailsCheckPoints,
  ChecklistDetailsFinding,
  ChecklistDetailsFindingTypeOption,
  FeatureFlag,
} from '../services/client.service';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AppService } from '../services/app.service';
import { forkJoin, catchError, of } from 'rxjs';
import { VideoPlayerService } from '../services/video-player.service';
import { isPlatformBrowser } from '@angular/common';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { VideoPlayerComponent } from '../video-player/video-player.component';
import { CarouselComponent } from '../carousel/carousel.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import {
  ButtonModule,
  IconModule,
  StructuredListModule,
  TilesModule,
} from 'carbon-components-angular';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { VehicleWalkthroughComponent } from '../vehicle-walkthrough/vehicle-walkthrough.component';
import { FeatureFlagService } from '../services/feature-flag.service';
@Component({
  selector: 'app-vvr-vehicle-walkthrough',
  templateUrl: './vvr-vehicle-walkthrough.component.html',
  styleUrls: ['./vvr-vehicle-walkthrough.component.scss'],
  standalone: true,
  imports: [
    MatExpansionModule,
    MatIconModule,
    VideoPlayerComponent,
    CarouselComponent,
    MatAccordion,
    VvrVehicleWalkthroughComponent,
    VehicleWalkthroughComponent,
    MatDialogModule,
    MatCardModule,
    RouterModule,
    TilesModule,
    NgxExtendedPdfViewerModule,
    MatTabsModule,
    ButtonModule,
    StructuredListModule,
    IconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatMenuModule,
    MatTooltipModule,
  ],
})
export class VvrVehicleWalkthroughComponent implements OnInit {
  reportResponse!: ChecklistDetailsResponse;
  @ViewChild('imageModal') imageModal: any;
  modalImageUrl: string | undefined;
  modalImageAlt: string | undefined;
  modelMedia!: ChecklistDetailsFileLinkWithThumbnail[];
  correntSellectedModel: number = 0;
  mediaElememt: string = '';
  @ViewChild('modelVideo') modelVideo!: ElementRef<HTMLVideoElement>;
  dealerImageDetails: StyleSettingsDealerImage | undefined;
  token: string = '';
  introOutroMediaData!: DealerMediaResponse;
  isWalkthroughEnabled: boolean | undefined;
  isDealerBrandingEnabled: boolean = false;
  featureName: string = "Dealer Branding";
  resultSet: FeatureFlag[] = [];

  constructor(
    private client: Client,
    private route: ActivatedRoute,
    private appService: AppService,
    private videoPlayerService: VideoPlayerService,
    private flagService: FeatureFlagService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.route.queryParams.subscribe((params) => {
        this.token = params['token'];
        forkJoin({
          data1: this.client.getChecklistDetails(this.token, true, 'EN'),
          data2: this.appService.getStyleSettings(this.token),
          dealerMedia: this.appService.getDealerMediaResponse(this.token).pipe(
            catchError((error) => {
              this.appService.handleErrorMessage(error);
              return of(null);
            })
          ),
        }).subscribe({
          next: (results: any) => {
            this.introOutroMediaData = results.dealerMedia;
            if (results.data1) {
              this.isWalkthroughEnabled =
                results.data1.categories?.some(
                  (category: ChecklistDetailsCategories) =>
                    category.checkpoints?.some(
                      (checkpoint: ChecklistDetailsCheckPoints) =>
                        checkpoint.isWalkthroughEnabled === true
                    )
                ) ?? false;
              this.reportResponse = results.data1;
              this.modifyChecklistDetailsResponse(this.reportResponse);
            }
            this.dealerImageDetails = results.data2.dealerImage;
          },
        });
      });
    }
    this.emitFeatureFlagStatus();
  }

  hasWalkthroughEnabledCheckpoints(
    category: ChecklistDetailsCategories
  ): boolean {
    return (
      category.checkpoints?.some(
        (checkpoint: ChecklistDetailsCheckPoints) =>
          checkpoint.isWalkthroughEnabled
      ) || false
    );
  }

  emitFeatureFlagStatus() {
    if (this.featureName && this.flagService.resultSet?.length) {
      const isEnabled = this.flagService.isFeatureEnabled(this.featureName, this.flagService.resultSet);
      this.isDealerBrandingEnabled = isEnabled;
    } 
  }

  closeMediaPlayerModal(
    media: ChecklistDetailsFileLinkWithThumbnail[] | any,
    position: number
  ) {
    this.modalImageUrl = '';
    if (this.modelVideo) {
      this.modelVideo.nativeElement.load();
    }
    this.modelMedia = media;
    if (position < 0) {
      position = 0;
    }
    if (position >= media.length) {
      position = media.length - 1;
    }
    if (media) {
      this.correntSellectedModel = position;
      this.modalImageUrl = media[position]?.url;
      this.imageModal.nativeElement.style.display = 'block';
      document
        .querySelector('.backdrop')
        ?.setAttribute('style', 'display:block');
    }
    this.mediaElememt = media[position].mimeType.includes('video')
      ? 'video'
      : 'image';
  }

  closeMediaModalWindow() {
    this.videoPlayerService.clearActivePlayer();
    if (this.modelVideo) {
      this.modelVideo.nativeElement.pause();
    }
    this.modalImageUrl = '';
    this.imageModal.nativeElement.style.display = 'none';
    document.querySelector('.backdrop')?.setAttribute('style', 'display:none');
  }

  isObjectEmpty(obj: any): boolean {
    return obj ? Object.keys(obj).length === 0 : true;
  }

  modifyChecklistDetailsResponse(checklistDetails: ChecklistDetailsResponse) {
    if (!checklistDetails.categories) return;

    checklistDetails.categories.forEach(
      (category: ChecklistDetailsCategories) => {
        if (!category.checkpoints) return;

        category.checkpoints.forEach(
          (checkpoint: ChecklistDetailsCheckPoints) => {
            if (
              checkpoint.status === 'NotOK' &&
              checkpoint.findings &&
              checkpoint.findingTypeOptions
            ) {
              let hasRedFinding = checkpoint.findings.some(
                (finding: ChecklistDetailsFinding) =>
                  checkpoint?.findingTypeOptions?.some(
                    (option: ChecklistDetailsFindingTypeOption) =>
                      option.id === finding?.findingType?.id &&
                      option.color === 'Red'
                  )
              );

              if (hasRedFinding) {
                checkpoint.status = 'NotOKRed';
              }
            }
          }
        );
      }
    );
  }
}
